import apiConfig from "../config/api";
import { get, requestDelete, put, post } from "../helpers/request";
const centrosURL = `${apiConfig.apiUri}api/sel/achsoffice`;
const prestacionesURL = `${apiConfig.apiUri}api/sel/exam`;
const cupoURL = `${apiConfig.apiUri}api/sel/quotas`;
const HolidayURL = `${apiConfig.apiUri}api/sel/holidayadministrative`;
const EmpresasURL = `${apiConfig.apiUri}api/sel/company`; 
//const EmpresasURL = `http://localhost:57182/api/sel/company`;

export const getAllCentrosAPI = () => get(`${centrosURL}/all`);

export const getCentroAPI = (id) => get(`${centrosURL}/${id}`);

export const deleteCentroAPI = (id) => requestDelete(`${centrosURL}/${id}`);

export const updateCentroAPI = (data) =>
  put(`${centrosURL}`, {
    body: JSON.stringify(data),
  });

export const createCentroAPI = (data) =>
  post(`${centrosURL}`, {
    body: JSON.stringify(data),
  });

export const getAllTerritories = () => get(`${centrosURL}/territories`);

export const getPrestacion = (id) => get(`${prestacionesURL}/${id}`);
export const deletePrestacion = (id) => requestDelete(`${prestacionesURL}/${id}`);
export const getPrestaciones = () => get(`${prestacionesURL}/all`);
export const createPrestacion = (data) =>
  post(`${prestacionesURL}`, {
    body: JSON.stringify(data),
  });
export const updatePrestacion = (data) =>
  put(`${prestacionesURL}`, {
    body: JSON.stringify(data),
  });
export const getCupo = (id) => get(`${cupoURL}/${id}`);
export const deleteCupo = (id) => requestDelete(`${cupoURL}/${id}`);
export const getCupos = () => get(`${cupoURL}/all`);
export const createCupo = (data) =>
  post(`${cupoURL}`, {
    body: JSON.stringify(data),
  });
export const updateCupo = (data) =>
  put(`${cupoURL}`, {
    body: JSON.stringify(data),
  });

export const getHolidayAdministrative = (start, end) => get(`${HolidayURL}/all`);

export const createHolidayAdministrative = (data) => 
  post(`${HolidayURL}`, {
    body: JSON.stringify(data),
  });

export const updateHolidayAdministrative = (data) => 
  put(`${HolidayURL}`, {
    body: JSON.stringify(data),
  });

export const deleteHolidayAdministrative = (id) => requestDelete(`${HolidayURL}/${id}`);

export const getEmpresas = () => get(`${EmpresasURL}/all`);

export const getEmpresa = (rut) => get(`${EmpresasURL}/${rut}`);

export const getDataEmpresa = (rut) => get(`${EmpresasURL}/data/${rut}`);

export const getDocumentAgreementApi = (rut, id) => get(`${EmpresasURL}/agreement/${rut}/${id}`);

export const postEmpresa = (data) =>
  post(`${EmpresasURL}`, {
    body: JSON.stringify(data),
});

export const putEmpresa = (data) =>
  put(`${EmpresasURL}`, {
    body: JSON.stringify(data),
  });


